// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ItemsPane-pane-e604{border-radius:16px;background-color:var(--ui-background-color-soft);overflow:hidden;-webkit-user-select:none;user-select:none}`, "",{"version":3,"sources":["webpack://./src/page/BasicInferenceScreen/ItemsPane.module.scss"],"names":[],"mappings":"AAAA,qBACE,kBAAA,CACA,gDAAA,CACA,eAAA,CACA,wBAAA,CAAA,gBAAA","sourcesContent":[".pane {\n  border-radius: 16px;\n  background-color: var(--ui-background-color-soft);\n  overflow: hidden;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `ItemsPane-pane-e604`
};
module.exports = ___CSS_LOADER_EXPORT___;
